var AdminPanel = {
  stav: false,

  _init: function() {
    if ($(".admin-bar").length) this.stav = true;
  },

  pridejMenu: function(nazev) {
    return new Promise(function(resolve) {
      if (!AdminPanel.stav) throw "nepřihlášený admin";

      let ul = $('.admin-bar li:contains("Uživatelské úpravy")')
        .closest("li")
        .find("ul");

      let li = $(`<li><a>${nazev}</a></li>`);

      li.appendTo(ul);

      return resolve(li);
    });
  }
};

AdminPanel._init();

export { AdminPanel };
